import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=8d4ccd1c&"
import script from "./FormText.vue?vue&type=script&lang=js&"
export * from "./FormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports